import { render, staticRenderFns } from "./DiverseLedgerEdit.vue?vue&type=template&id=6b0be91e"
import script from "./DiverseLedgerEdit.vue?vue&type=script&lang=ts"
export * from "./DiverseLedgerEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b0be91e')) {
      api.createRecord('6b0be91e', component.options)
    } else {
      api.reload('6b0be91e', component.options)
    }
    module.hot.accept("./DiverseLedgerEdit.vue?vue&type=template&id=6b0be91e", function () {
      api.rerender('6b0be91e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bookkeeping/DiverseLedgerEdit.vue"
export default component.exports